ready = ->
  $('.payment-scroller').on 'click', ->
    scrollToPayments()
    return

  hideNonVatInclusivePrices()

  getParameterData()

  overrideHeaderSignup()

  signupScrollBottomIfNeeded()

  setupCertificatePage() if $('.certificate-container')[0]

  showCoupon = false

scrollToPayments = ->
  if $("#pricing-options")
    $("html,body").animate
      scrollTop: $("#pricing-options").offset().top - 130
    , "slow"

getParameterData = ->
  if shouldGetCouponOrProductData()
    $.ajax({ url: couponCheckerPath().toString(), data: getQueryString(), method: "GET", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } })
      .then(fillDataFromParameters)
  if vatTaxableCountry() && currentUrl().path.indexOf("/purchased") == -1
    $.ajax({ url: vatCheckerPath().toString(), data: getQueryString(), method: "GET", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } })
      .then(setVatPricesForProducts)
      .fail(setPricesWithoutVatForProducts)

hideNonVatInclusivePrices = ->
  if vatTaxableCountry()
    if courseUrl()
      $(".default-product-price").addClass("hidden")
    else
      $(".small.course-price").addClass("hidden")

currentUrl = ->
  urlObj = { href: window.location.href, host: window.location.host, path: window.location.pathname, params: {} }
  window.location.search.toLowerCase().replace(/^\?/, '').split('&').forEach((query) ->
    urlObj.params[query.split("=")[0]] = query.split("=")[1]
  )
  return urlObj

isSecurePage = ->
  return true if currentUrl().path.indexOf("/purchased") > -1 || currentUrl().path.indexOf("/sign_in") > -1

urlHasCouponOrProductParams = ->
  return true if currentUrl().params["coupon"] || currentUrl().params["code"] ||
    currentUrl().params["couponcode"] || currentUrl().params["coupon_code"] || currentUrl().params["product_id"]

shouldGetCouponOrProductData = ->
  if !isSecurePage() && (courseUrl() || currentUrl().path.indexOf("/blog") > -1) && urlHasCouponOrProductParams()
    return true
  else
    return false

coursePath = ->
  $.url(courseUrl()).attr("path")

courseUrl = ->
  $('meta[id=fedora-data]').attr('data-course-url')

couponCheckerPath = ->
  "#{coursePath()}/coupon_and_product_data"

vatCheckerPath = ->
  if courseUrl()
    "#{coursePath()}/vat_rates_for_course_products"
  else
    "/vat_rates_for_school_default_products" + parameterizedCourseIds()

parameterizedCourseIds = ->
  "?" + $.param({ course_ids: $("#fedora-data").data().pageCourseIds })

vatTaxableCountry = ->
  $("meta[id=fedora-data]").attr("data-vat-country")

window.fillDataFromParameters = (data) ->
  fillCouponElements(data)
  selectProduct(data.selected_product_id)

fillCouponElements = (data) ->
  return unless data.coupon_param
  $('input#coupon_code').val(data.coupon_code)
  # within div 'coupon-discount-text'
  if data.discount_type == 'percent'
    $('.coupon-discount').text( data.discount_percent + '%') # coupon-discount span for setting the number

  if data.discounted_products.length == 0 # hide the entire discount message and show the unavailable message instead
    $('.coupon-discount-text').hide() # hide entire div
    $('.coupon-invalid-text').show().removeClass( 'hidden' )
  else
    for product in data.discounted_products
      if product.discount_type == 'percent'
        # in products list
        $('.discount.product_' + product.product_id + '> .coupon-discount').html(product.discount_percent + "%")
      else if product.discount_type == 'amount'
        # in products list
        $('.discount.product_' + product.product_id + '> .coupon-discount').html(product.formatted_discount)
        $('.coupon-discount').text(product.formatted_discount) # in the banner

      $('.default-product-price.product_' + product.product_id).text(product.original_price)
      $('.default-product-price.product_' + product.product_id).addClass( 'strike-through-price' )

      $('.coupon-price.product_' + product.product_id).text( product.formatted_final_price )

      $('.discount.product_' + product.product_id).show().removeClass( 'hidden' )
  $('.coupon_banner').show().removeClass( 'hidden' )
  $('.coupon-code-applied').show().removeClass( 'hidden' )

setVatPricesForProducts = (data) ->
  if courseUrl()
    for product in data.vat_adjusted_products
      $('.default-product-price.product_' + product.product_id).text( product.formatted_final_price )
      $(".default-product-price").removeClass("hidden")
  else
    for product in data.vat_adjusted_products
      $("#course-box-price-product-" + product.product_id).text( product.formatted_final_price )
      $(".small.course-price").removeClass("hidden")

setPricesWithoutVatForProducts = ->
  if courseUrl()
    $(".default-product-price").removeClass("hidden")
  else
    $(".small.course-price").removeClass("hidden")

selectProduct = (product_id) ->
  return unless product_id and $('input[id=product_id_' + product_id + ']').length > 0
  $('input[id=product_id_' + product_id + ']').prop('checked', true)
  $('.checkout-button-group').removeClass( 'active' )
  $('.checkout-button-group.product_' + product_id).addClass( 'active' )

# If they're on a course page, override header signup button to course sign up
overrideHeaderSignup = ->
  if ($(".btn-header-enroll").length)
    $(".navbar-nav .btn.btn-primary").click (e) ->
      e.preventDefault()
      $(".btn-header-enroll").click()

# If they've tried to pre-enroll and are given a flash message, autoscroll to the bottom signup form
signupScrollBottomIfNeeded = ->
  if ($(".auto-scroll-on-page-load").length)
    scrollToPayments()

setupCertificatePage = ->
  showConfetti()
  setupDownloadBar()


setupDownloadBar = ->
  $('.download-button').click (evt) ->
    $(this).text("Downloading...")
    $(this).addClass("hidden")

showConfetti = ->
  queryString = getQueryString()

  if queryString.certificate_first_issued
    config = {
      target: "confetti-canvas"
      max: 800
      size: 2
      animate: true
      props: ["square", "triangle", "line"]
      colors: [[165, 104, 246], [230, 61, 135], [0, 199, 228], [253, 214, 126]]
      clock: 50
    }

    # $(".course-block.block").css({
    #   position: "absolute"
    #   "z-index": 3
    #   background: "none"
    #   left: "50%"
    #   "margin-left": "-200px"
    # })

    appendTo = $(".course-mainbar").css("min-height": "900px")

    opacityMask = $("<div>")
      .addClass("confetti-mask")
      .height(appendTo.innerHeight())
      .width(appendTo.innerWidth())
      .appendTo(appendTo)
      # .fadeOut(7000)

    canvas = $("<canvas>")
      .addClass("confetti-canvas")
      .attr("id", "confetti-canvas")
      .height(appendTo.innerHeight())
      .width(appendTo.innerWidth())
      .appendTo(appendTo)

    setTimeout ->
      canvas.addClass("fader")

      setTimeout ->
        opacityMask.addClass("fader")
      , 2000
    , 1000

    ConfettiGenerator(config).render()

$(document).ready(ready)
$(document).on('page:load', ready)
